// Basic
import PropTypes from 'prop-types';
import { useState } from 'react';
// Store & actions
import actionsContracts from '../../api/actionsContracts';
// Components
import Entity from '@/common-utils/components/renders/entity/Entity';
import HeaderTitle from '@/common-utils/components/renders/modal/components/headers/HeaderTitle/HeaderTitle';
import FooterForm from '@/common-utils/components/renders/modal/components/footers/FooterForm/FooterForm';
import { Modal, ModalBody, ModalContent, ModalTrigger } from '@/common-utils/components/ui/modal';
// Common
import { useToast } from '@/common-utils/hooks/use-toast';
// Lang
import { nsContract } from '@/app/i18n/namespaces';

/**
 * @param root0
 * @param root0.trigger
 * @param root0.isOpen
 * @param root0.setIsOpen
 * @param root0.contractId
 * @param root0.merchantAccountId
 * @param root0.setLaunchRefetch
 * @returns {JSX.Element} ModalRemoveContract
 */
function ModalRemoveContract({
    trigger = null,
    isOpen = false,
    setIsOpen = () => { },
    contractId,
    merchantAccountId,
    setLaunchRefetch
}) {
    const [showSubmitButton, setShowSubmitButton] = useState(true);
    const { toast } = useToast();

    // Success and Error Handlers
    const onSuccess = () => {
        setShowSubmitButton(false);
        setIsOpen(false);
        setLaunchRefetch(true);
        toast({
            description: <Entity entity='modal.delete.success' namespace={nsContract} />,
            variant: 'success'
        });
    };

    const onError = () => {
        setShowSubmitButton(false);
        setIsOpen(false);
        toast({
            description: <Entity entity='modal.delete.error' namespace={nsContract} />,
            variant: 'danger'
        });
    };

    // API Calls
    const submitRemoveContract = actionsContracts.removeContract(onSuccess, onError);

    const onClose = () => {
        setIsOpen(false);
        if (submitRemoveContract.isSuccess) {
            setLaunchRefetch(true);
        }
    };

    // Renders
    const content = (
        <ModalContent className='max-w-lg'>
            <HeaderTitle title='modal.delete.title' namespace={nsContract} />
            <ModalBody>
                <div className='flex flex-col items-center gap-y-4 '>
                    <Entity entity='modal.delete.text' namespace={nsContract} className='whitespace-normal break-words' />
                    <Entity entity='modal.delete.warning' namespace={nsContract} />
                </div>
            </ModalBody>
            <FooterForm
                onSubmit={() => submitRemoveContract.mutate({ contractAccessId: merchantAccountId, contractId })}
                isSubmitting={submitRemoveContract.isLoading}
                showSubmitButton={showSubmitButton}
            />
        </ModalContent>
    );

    if (trigger) {
        return (
            <Modal>
                <ModalTrigger>{trigger}</ModalTrigger>
                {content}
            </Modal>
        );
    }

    return (
        <Modal open={isOpen} onOpenChange={onClose}>
            {content}
        </Modal>
    );
}

ModalRemoveContract.propTypes = {
    trigger: PropTypes.element,
    isOpen: PropTypes.bool.isRequired,
    setIsOpen: PropTypes.func.isRequired,
    contractId: PropTypes.string.isRequired,
    merchantAccountId: PropTypes.string.isRequired,
    setLaunchRefetch: PropTypes.func.isRequired
};

export default ModalRemoveContract;